import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { RoleShared } from '../../../models/interface/role.interface';
import { MuComponent } from '../../../types/MuComponent.componetent';
@Component({
  selector: 'app-mu-form-checkbox-role',
  templateUrl: './mu-form-checkbox-role.component.html',
  styleUrls: ['./mu-form-checkbox-role.component.sass'],
})
export class MuFormCheckboxRoleComponent extends MuComponent implements OnInit {
  @Input() formData: UntypedFormGroup;
  @Input() controlName: string;
  @Input() rolesList: RoleShared;

  constructor() {
    super();
  }

  muOnDestroy(): void {
    /** */
  }

  muOnInit(): void {
    /** */
  }
}
